import React from "react";
import { showSuccessNotification } from "../../../helpers/notifications";
import useTranslation from "../../../helpers/useTranslation";
import getThemeColors from "../../../utils/getColorTheme";
import { useTheme } from "../../../contexts/ThemeContext";
import { MessagesdI18n } from "./ConversationUser.i18n";

interface ButtonCopyMessageProps {
  message: string;
}

export function ButtonCopyMessage({ message }: ButtonCopyMessageProps) {
  const { t } = useTranslation(MessagesdI18n);
  const { addTheme } = useTheme();
  const { theme } = getThemeColors(addTheme);

  function copyToClipboardFallback(text: string): void {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);

      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      document.execCommand("copy");

      document.body.removeChild(textarea);

      showSuccessNotification(t("notifications.successCopyClipboard"));
    } catch (error) {
      console.error("Erro ao copiar o texto: ", error);
    }
  }

  const buttonStyle: React.CSSProperties = {
    backgroundColor: "transparent",
    borderStyle: "none",
    outlineStyle: "none",
    color: "inherit",
    marginBottom: 0,
    marginTop: 8,
    marginRight: 8,
    cursor: "pointer",
  };

  return (
    <button
      style={buttonStyle}
      onClick={() => copyToClipboardFallback(message)}
      aria-label="Copy message to clipboard"
    >
      <i className="bx bx-copy" style={{ color: theme }} />
    </button>
  );
}
